import serverApi from "../../utils/serverApi"

const adminLogsService = {
  getAdminLogsData: (data) => serverApi({ uri: "admin/admins/admin-logs", method: "GET", data }),
}

export default adminLogsService
